export const messages = {
  en: {
    notepadManage: {
      search: {
        title: 'Search Conditions',
        noteType: 'Please select feedback type',
        roomName: 'Please select room',
        state: 'Please select status',
        createUserName: 'Please select registrant',
        objName: 'Please select owner name'
      },
      list: {
        title: 'Owner Feedback'
      },
      table: {
        noteType: 'Type',
        roomName: 'Room',
        objName: 'Contact',
        link: 'Contact Phone',
        state: 'Status',
        createTime: 'Record Time',
        createUserName: 'Registrant',
        title: 'Content'
      },
      state: {
        following: 'Following',
        completed: 'Completed',
        transferred: 'Transferred'
      },
      operation: {
        follow: 'Follow',
        progress: 'Progress',
        transfer: 'Transfer to Repair',
        repairDetail: 'Repair Detail'
      },
      tip: 'Tip: Please register at the business acceptance page',
      edit: {
        title: 'Edit',
        roomName: 'Room',
        objName: 'Contact',
        link: 'Contact Phone',
        noteType: 'Type',
        Content: 'Content',
        selectNoteType: 'Please select feedback type'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Confirm to delete notepad?'
      },
      addDetail: {
        title: 'Follow Up',
        state: 'Status',
        content: 'Follow Content',
        selectState: 'Please select status',
        contentPlaceholder: 'Please enter follow content'
      },
      detail: {
        title: 'Follow Progress',
        index: 'No.',
        createUser: 'Handler',
        createTime: 'Handle Time',
        content: 'Handle Content'
      },
      ownerRepair: {
        title: 'Transfer to Repair',
        repairType: 'Repair Type',
        repairObjName: 'Room',
        repairName: 'Repairer',
        tel: 'Contact',
        appointmentTime: 'Appointment Time',
        context: 'Repair Content',
        selectRepairType: 'Please select repair type',
        repairObjNamePlaceholder: 'Please enter room',
        repairNamePlaceholder: 'Please enter repairer',
        telPlaceholder: 'Please enter contact',
        selectTime: 'Select appointment time',
        contextPlaceholder: 'Please enter repair content'
      },
      validate: {
        noteType: 'Type cannot be empty',
        title: 'Content cannot be empty',
        titleMaxLength: 'Content cannot exceed 256 characters',
        state: 'Status cannot be empty',
        content: 'Content cannot be empty',
        repairType: 'Repair type cannot be empty',
        repairObjName: 'Room cannot be empty',
        repairName: 'Repairer cannot be empty',
        repairNameLength: 'Repairer name must be between 2-10 characters',
        tel: 'Contact cannot be empty',
        telFormat: 'Invalid contact format',
        appointmentTime: 'Appointment time cannot be empty',
        context: 'Repair content cannot be empty',
        contextMaxLength: 'Repair content cannot exceed 2000 characters'
      }
    }
  },
  zh: {
    notepadManage: {
      search: {
        title: '查询条件',
        noteType: '请选择反馈类型',
        roomName: '请选择房屋',
        state: '请选择状态',
        createUserName: '请选择登记人',
        objName: '请选择业主名称'
      },
      list: {
        title: '业主反馈'
      },
      table: {
        noteType: '类型',
        roomName: '房屋',
        objName: '联系人',
        link: '联系电话',
        state: '状态',
        createTime: '记录时间',
        createUserName: '登记人',
        title: '内容'
      },
      state: {
        following: '跟进中',
        completed: '完成',
        transferred: '已转报修单'
      },
      operation: {
        follow: '跟进',
        progress: '进度',
        transfer: '转报修单',
        repairDetail: '报修详情'
      },
      tip: '温馨提示：请到业务受理页面登记',
      edit: {
        title: '修改',
        roomName: '房屋',
        objName: '联系人',
        link: '联系电话',
        noteType: '类型',
        content: '内容',
        selectNoteType: '请选择反馈类型'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除记事薄?'
      },
      addDetail: {
        title: '跟进',
        state: '状态',
        content: '跟进内容',
        selectState: '请选择状态',
        contentPlaceholder: '请填写跟进内容'
      },
      detail: {
        title: '跟进进度',
        index: '序号',
        createUser: '处理人',
        createTime: '处理时间',
        content: '处理内容'
      },
      ownerRepair: {
        title: '转报修单',
        repairType: '报修类型',
        repairObjName: '房屋',
        repairName: '报修人',
        tel: '联系方式',
        appointmentTime: '预约时间',
        context: '报修内容',
        selectRepairType: '请选择报修类型',
        repairObjNamePlaceholder: '请填写房屋',
        repairNamePlaceholder: '请填写报修人',
        telPlaceholder: '请填写联系方式',
        selectTime: '选择预约时间',
        contextPlaceholder: '请填写报修内容'
      },
      validate: {
        noteType: '类型不能为空',
        title: '内容不能为空',
        titleMaxLength: '内容不能超过256个字符',
        state: '状态不能为空',
        content: '内容不能为空',
        repairType: '报修类型不能为空',
        repairObjName: '房屋不能为空',
        repairName: '报修人不能为空',
        repairNameLength: '报修人名称必须在2至10字符之间',
        tel: '联系方式不能为空',
        telFormat: '联系方式格式不正确',
        appointmentTime: '预约时间不能为空',
        context: '报修内容不能为空',
        contextMaxLength: '报修内容不能超过2000个字符'
      }
    }
  }
}